import React from 'react';

import { Grid, Stack, Help, Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import { STATUS_ACTIVE, PREVIEW_BEFORE_START, PUBLIC_RULE } from './constants';

export const Options = () => {
  return (
    <Grid container xs={12} alignItems={'flex-start'}>
      <Grid item xs={4}>
        <Section title={'Start Options'}>
          <Stack>
            <Stack>
              <FormField.Checkbox
                label={'Status “Active”'}
                name={STATUS_ACTIVE}
                padding={0}
              />
            </Stack>
            <Stack direction={'row'} style={{ alignItems: 'center' }}>
              <Stack>
                <FormField.Checkbox
                  label={'Preview before start'}
                  name={PREVIEW_BEFORE_START}
                  padding={0}
                />
              </Stack>
              <Help>
                A simulation of the rule execution would be done now and an
                approval email would be sent to you. The rule would be activated
                only after you will approve it.
              </Help>
            </Stack>
          </Stack>
        </Section>
      </Grid>

      <Grid item xs={4}>
        <Section title={'Sharing'}>
          <Stack direction={'row'} alignItems={'center'}>
            <Stack>
              <FormField.Checkbox
                label={'Public rule'}
                name={PUBLIC_RULE}
                padding={0}
              />
            </Stack>
            <Help>The rule and rule results will be visible for all users</Help>
          </Stack>
        </Section>
      </Grid>
    </Grid>
  );
};
